import Chart from "react-apexcharts";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { useEffect, useState } from "react";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import { dashboardMechanicGrowth } from "../../config/apiSPA.js";
function mpGrowthChartConfig(datas) {
  const themeColor = getComputedStyle(document.body).getPropertyValue("--bs-theme").trim();
  let series = [];
  let label = [];
  datas.forEach((data) => {
    series.push(data.jumlah);
    label.push(DateFormat(data.created_at));
  });
  return {
    series: [
      {
        name: "Mechanic Growth",
        data: series,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        curve: "smooth",
        width: 2,
        colors: themeColor,
      },
      tooltip: {
        fixed: {
          enabled: true,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: label,
        labels: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        show: false,
      },
      grid: {
        show: false,
      },
    },
  };
}
function ManpowerGrowth() {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    dashboardMechanicGrowth().then((res) => setChartData(res));
  }, []);
  return (
    <>
      <Card>
        <CardBody className="m-5px bg-inverse bg-opacity-10">
          <div className="d-flex fw-bold small mb-3">
            <span className="flex-grow-1">Mechanic Growth</span>
          </div>
          <div>{chartData.length > 0 ? <Chart series={mpGrowthChartConfig(chartData).series} type="line" options={mpGrowthChartConfig(chartData).options} height={150} /> : <p>loading....</p>}</div>
        </CardBody>
      </Card>
    </>
  );
}
export default ManpowerGrowth;
